import React from "react";
import { groupBy } from "lodash";
import { COMMENT_OBJECT_TYPE } from "common/constants";
import { useGetCommentsForObjectQuery } from "../../generated/graphql";
import { spacing } from "../../stitches.config";
import { formatDate } from "../ActivityFeed/dateHelper";
import { FlexColumn } from "../Common/__styles__/Layout";
import { Body } from "../Common/Typography";
import { Wrapper } from "./__styles__/Thread";
import { Comment } from "./Comment";

export const Thread = ({
  objectId,
  objectType,
}: {
  objectId: string;
  objectType: COMMENT_OBJECT_TYPE;
}) => {
  const { data } = useGetCommentsForObjectQuery({
    variables: {
      objectId,
      objectType,
    },
  });

  const comments = data?.getCommentsForObject || [];
  const sortedComments = comments.sort((a, b) => {
    return a.createdAt.getTime() - b.createdAt.getTime();
  });
  const groupedCommentsByDay = groupBy(sortedComments, comment =>
    formatDate({ dateString: comment.createdAt }),
  );

  return (
    <Wrapper>
      <FlexColumn>
        {Object.entries(groupedCommentsByDay).map(([day, comments]) => (
          <FlexColumn key={day} style={{ gap: `${spacing.s}` }}>
            <Body size="small" type="emphasis">
              {day}
            </Body>
            {comments.map(comment => (
              <Comment key={comment.id} comment={comment} />
            ))}
          </FlexColumn>
        ))}
      </FlexColumn>
    </Wrapper>
  );
};
